import { SvgIcon, SvgIconProps } from '@mui/material';

export function CipIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16" fill="none">
      {/* Radiating lines from center - left */}
      <path d="M7.97 6.6L8.76 6.25" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
      <path d="M8.76 4.18L7.97 3.84" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>

      {/* Radiating lines - top */}
      <path d="M10.14 2.72L9.82 1.88" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
      <path d="M12.1 2.72L12.43 1.88" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>

      {/* Radiating lines - right */}
      <path d="M13.48 4.18L14.27 3.84" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
      <path d="M13.48 6.25L14.27 6.6" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>

      {/* Radiating lines - bottom */}
      <path d="M10.14 7.72L9.82 8.55" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
      <path d="M12.43 8.56L12.1 7.72" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>

      {/* Central circle */}
      <circle cx="11.12" cy="5.22" r="2.56" stroke="currentColor" strokeWidth="1" fill="none"/>

      {/* Document/page shape */}
      <path d="M14.56 11.02V13.01C14.56 13.54 14.41 14.05 14.15 14.42C13.88 14.79 13.52 15 13.15 15H1.85C1.48 15 1.12 14.79 0.855 14.42C0.59 14.05 0.441 13.54 0.441 13.01V3.04C0.441 2.52 0.6 2.01 0.882 1.64C1.165 1.26 1.548 1.05 1.947 1.05H7.22"
            stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" fill="none"/>

      {/* Chart inside document */}
      <path d="M5.89 9.92H7.54V11.57" stroke="currentColor" strokeWidth="0.7" strokeLinecap="round"/>
      <path d="M7.54 9.92L5.21 12.25L3.83 10.88L2.05 12.67" stroke="currentColor" strokeWidth="0.7" strokeLinecap="round"/>
    </SvgIcon>
  );
}
